import { of } from 'rxjs';
import { Inject, Injectable } from '@angular/core';
import { CustomHeaderAdapter } from '../../../models/custom-header.model';
import articlesJson from '../articles.json';
import categoriesJson from '../categories.json';
import customHeadersJson from '../custom-header.json';
import footerJson from '../footer.json';
import userLoginJson from '../user-login.json';
import { LIB_CONFIG } from '../../../lib-config';
import { LibConfig } from '../../../models/lib-config.model';
import { ApplicationRoutedUids } from '../uids-to-link-within-app';

@Injectable({
  providedIn: 'root',
})
export class CmsJsonService {
  constructor(private customHeaderAdapter: CustomHeaderAdapter, @Inject(LIB_CONFIG) public config: LibConfig) {}

  getArticle(uid: string) {
    return of(this.getArticlesById(uid));
  }

  getCategoriesWithSubcategories(uid: string) {
    const searchedCategory = this.getCategoryWithSubcategoriesById(uid);

    this.setExternalLinksForLandingPage(searchedCategory?.sub_categories);

    return of(searchedCategory);
  }

  getArticlesOfCategory(uid: string) {
    const selectedCategory = this.getCategoryWithSubcategoriesById(uid);

    selectedCategory.articles = (selectedCategory?.articles as any[]).map((categoryArticle) =>
      this.getArticlesById(categoryArticle.uid)
    );
    return of(selectedCategory);
  }

  getCategoriesQuickLinks() {
    const quickLinkCategories = categoriesJson?.data?.categories?.filter((category) => category.quickLink === true);
    this.setExternalLinksForLandingPage(quickLinkCategories);
    return of(quickLinkCategories);
  }

  getCustomHeader(uid: string) {
    const selectedCustomHeader = customHeadersJson?.data?.customHeaders?.find(
      (customHeader) => customHeader.Uid === uid
    );
    return of(this.customHeaderAdapter?.adapt(selectedCustomHeader));
  }

  getFooter() {
    return of(footerJson);
  }

  getUserLogin() {
    return of(userLoginJson?.data?.userLogin);
  }

  private getArticlesById(uid: string) {
    return articlesJson?.data?.articles?.find((article) => article.uid === uid);
  }

  private getCategoryWithSubcategoriesById(uid: string) {
    return categoriesJson?.data?.categories?.find((category) => category.uid === uid);
  }

  public setExternalLinksForLandingPage(categories: any[]): any[] {
    if (!categories?.length) {
      return categories;
    }
    categories.forEach((category) => {
      if (!category?.externalUrl) {
        return category;
      }
      // internal re-direct within the compax application or a reverse proxy setup
      if (
        category.externalUrl &&
        category.externalUrl.charAt(0) === '/' &&
        !ApplicationRoutedUids.includes(category.uid)
      ) {
        //todo: delete if usage not found
        // category.externalUrl = this?.config?.compaxAngularApi?.baseUrl
        //   .substr(0, this?.config?.compaxAngularApi?.baseUrl.indexOf('/care'))
        //   .concat(category.externalUrl);
      }
    });
    return categories;
  }
}
